import { render, staticRenderFns } from "./preferencereport.vue?vue&type=template&id=b039ab78&scoped=true&"
import script from "./preferencereport.vue?vue&type=script&lang=js&"
export * from "./preferencereport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b039ab78",
  null
  
)

export default component.exports